import { authHeader } from "@/_helpers/auth-header";
import { handleResponse } from "@/_helpers/handle-response";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_ITTENTION;

export const aoiservice = {
  postAnalysis,
  getAnalysis,
  getAnalysisAOI,
  postAnalysisImg
};

function getAnalysisAOI(
  media = null,
  created = null,
  limit = null,
  offset = null
) {
  const requestOptions = {
    method: "get",
    url: "/processes/api/v1/aoitestreport",
    data: {
      media: media,
      created: created,
      limit: limit,
      offset: offset
    },
    headers: authHeader()
  };
  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function postAnalysis(data) {
  const requestOptions = {
    method: "post",
    url: "/processes/api/v1/aoitestreport/",
    data: data,
    headers: authHeader()
  };
  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function postAnalysisImg(data, uuid) {
  const requestOptions = {
    method: "post",
    url: "/processes/api/v1/aoitestreport/" + uuid,
    data: data,
    headers: authHeader()
  };
  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function getAnalysis(uuid) {
  const requestOptions = {
    method: "get",
    url: "/processes/api/v1/aoitestreport/" + uuid,
    headers: authHeader()
  };
  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}
